import React from 'react';
import { bem } from '../../../../core/design/bem';
import CdnImage from '../../../CdnImage';
import { Image } from '../../types';

const css = bem('CarouselBlock');

type ImageVariantProps = {
  image?: Image;
  title?: string;
  imageProps?: any;
};

const ImageVariant = ({ title, image, imageProps }: ImageVariantProps): JSX.Element | null => (
  <div className={css('image')}>
    <CdnImage src={image} maxWidth={600} maxHeight={imageProps?.maxHeight} srcSet openOnClick />
    {title}
  </div>
);

ImageVariant.defaultProps = {
  image: undefined,
  title: undefined,
  imageProps: undefined,
};

export default ImageVariant;
